import { useTranslation } from 'react-i18next'

import { AIButtonText } from '../../../AIButton'
import { BUTTON_HEIGHT_24 } from '../../../Button'
import { QA_NAME_DASHBOARD_BIRDVIEW_GRETA_APPROVE_ALL } from '../../DashboardBirdview.constants.qa'

// TODO Approve all has no endpoint yet (Phase 3): the handler is a stub until
// the proposals API ships.
function BirdviewGretaApproveAllButton() {
  const { t } = useTranslation()

  function handleApproveAll() {}

  return (
    <AIButtonText
      isInline
      height={BUTTON_HEIGHT_24}
      qaName={QA_NAME_DASHBOARD_BIRDVIEW_GRETA_APPROVE_ALL}
      text={t('DashboardBirdview.GretaApproveAllKey')}
      onClick={handleApproveAll}
    />
  )
}

export default BirdviewGretaApproveAllButton
